module.exports = __webpack_public_path__ + "static/media/center-top.c4ad2801.png";